"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Sidebar_1 = __importDefault(require("@components/Sidebar/Sidebar"));
var gddStyle = __importStar(require("./GDDView.module.scss"));
var react_router_dom_1 = require("react-router-dom");
var Overview_1 = __importDefault(require("@views/Overview"));
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var modalSlice_1 = require("@store/slices/modalSlice");
var MechanicsView_1 = __importDefault(require("@views/MechanicsView"));
var GameplayView_1 = __importDefault(require("@views/GameplayView"));
var LocationsView_1 = __importDefault(require("@views/LocationsView"));
var CharactersView_1 = __importDefault(require("@views/CharactersView"));
var EditGDDForm_1 = __importDefault(require("@components/Forms/GddForm/EditGDDForm"));
var gameplayAPI_1 = require("@services/gameplayAPI");
var gameplaySlice_1 = require("@store/slices/gameplaySlice");
var gddAPI_1 = require("@services/gddAPI");
var gddSlice_1 = require("@store/slices/gddSlice");
var mechanicsAPI_1 = require("@services/mechanicsAPI");
var mechanicsSlice_1 = require("@store/slices/mechanicsSlice");
var mechanicsTypesAPI_1 = require("@services/mechanicsTypesAPI");
var mechanicsTypeSlice_1 = require("@store/slices/mechanicsTypeSlice");
var charactersAPI_1 = require("@services/charactersAPI");
var characterSlices_1 = require("@store/slices/characterSlices");
var locationsAPI_1 = require("@services/locationsAPI");
var locationsSlice_1 = require("@store/slices/locationsSlice");
var loaderSlice_1 = require("@store/slices/loaderSlice");
var Profile_1 = __importDefault(require("@components/Profile/Profile"));
function GDDView() {
    var _this = this;
    var selectedGDD = (0, react_redux_1.useSelector)(function (state) { return state.authSlice; }).selectedGDD;
    var dispatch = (0, react_redux_1.useDispatch)();
    var fetchAll = function () { return __awaiter(_this, void 0, void 0, function () {
        var _a, gddResponse, gameplayResponse, mechanicsResponse, allTypesResponse, allCharactersResponse, allLocationsResponse, allMechanics, allTypes, allCharacters, allLocations, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!selectedGDD) {
                        dispatch((0, modalSlice_1.showModal)({
                            text: "GDD was not found",
                            activeModal: modalSlice_1.ActiveModal.Redirect,
                        }));
                        return [2 /*return*/];
                    }
                    dispatch((0, loaderSlice_1.setLoading)(true));
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, Promise.all([
                            (0, gddAPI_1.getGDDAPI)(selectedGDD),
                            (0, gameplayAPI_1.getGameplayAPI)(selectedGDD),
                            (0, mechanicsAPI_1.getAllMechanicsAPI)(selectedGDD),
                            (0, mechanicsTypesAPI_1.getAllTypesAPI)(selectedGDD),
                            (0, charactersAPI_1.getAllCharactersAPI)(selectedGDD),
                            (0, locationsAPI_1.getAllLocationsAPI)(selectedGDD),
                        ])];
                case 2:
                    _a = _b.sent(), gddResponse = _a[0], gameplayResponse = _a[1], mechanicsResponse = _a[2], allTypesResponse = _a[3], allCharactersResponse = _a[4], allLocationsResponse = _a[5];
                    if (gddResponse.success)
                        dispatch((0, gddSlice_1.createGDD)(gddResponse.gdd));
                    if (gameplayResponse.success) {
                        dispatch((0, gameplaySlice_1.editGameplay)(gameplayResponse.gameplay));
                    }
                    if (mechanicsResponse.success) {
                        allMechanics = mechanicsResponse.mechanics;
                        if (allMechanics.length > 0)
                            allMechanics.forEach(function (m) {
                                dispatch((0, mechanicsSlice_1.addMechanic)(m));
                            });
                    }
                    if (allTypesResponse.success) {
                        allTypes = allTypesResponse.types;
                        if (allTypes.length > 0)
                            allTypes.forEach(function (t) { return dispatch((0, mechanicsTypeSlice_1.addMechanicType)(t)); });
                    }
                    if (allCharactersResponse.success) {
                        allCharacters = allCharactersResponse.characters;
                        console.log(allCharacters);
                        if (allCharacters.length > 0)
                            allCharacters.forEach(function (c) { return dispatch((0, characterSlices_1.addCharacter)(c)); });
                    }
                    if (allLocationsResponse.success) {
                        allLocations = allLocationsResponse.locations;
                        if (allLocations.length > 0)
                            allLocations.forEach(function (l) { return dispatch((0, locationsSlice_1.addLocation)(l)); });
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _b.sent();
                    dispatch((0, modalSlice_1.showModal)({
                        text: "Failed to load GDD data",
                        activeModal: modalSlice_1.ActiveModal.Redirect,
                    }));
                    return [3 /*break*/, 5];
                case 4:
                    dispatch((0, loaderSlice_1.setLoading)(false));
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useLayoutEffect)(function () {
        if (selectedGDD)
            fetchAll();
    }, [selectedGDD]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: gddStyle.container, children: [(0, jsx_runtime_1.jsx)(Sidebar_1.default, {}), (0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsx)("div", { className: gddStyle.routes_container, children: (0, jsx_runtime_1.jsxs)(react_router_dom_1.Routes, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "info", element: (0, jsx_runtime_1.jsx)(Overview_1.default, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "editGdd", element: (0, jsx_runtime_1.jsx)(EditGDDForm_1.default, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "mechanics/*", element: (0, jsx_runtime_1.jsx)(MechanicsView_1.default, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "gameplay", element: (0, jsx_runtime_1.jsx)(GameplayView_1.default, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "locations/*", element: (0, jsx_runtime_1.jsx)(LocationsView_1.default, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "characters/*", element: (0, jsx_runtime_1.jsx)(CharactersView_1.default, {}) })] }) }), (0, jsx_runtime_1.jsx)(Profile_1.default, {})] }));
}
exports.default = GDDView;
